import AudioPreviewer from './audioPreviewer'

export default AudioPreviewer
